/**
 * 常量定义
 */

/**
 * 商品状态
 */
export const GOODS_STATUS = {
  DRAFT: 0,      // 草稿
  ONLINE: 1,     // 上架
  OFFLINE: 2     // 下架
}

/**
 * 商品状态文本映射
 */
export const GOODS_STATUS_TEXT = {
  [GOODS_STATUS.DRAFT]: '草稿',
  [GOODS_STATUS.ONLINE]: '上架',
  [GOODS_STATUS.OFFLINE]: '下架'
}

/**
 * 商品状态类型映射（用于Element UI标签颜色）
 */
export const GOODS_STATUS_TYPE = {
  [GOODS_STATUS.DRAFT]: 'info',
  [GOODS_STATUS.ONLINE]: 'success',
  [GOODS_STATUS.OFFLINE]: 'warning'
}

/**
 * 文章状态
 */
export const ARTICLE_VALIDATION = {
  OFFLINE: 0,    // 下架
  ONLINE: 1      // 上架
}

/**
 * 文章状态文本映射
 */
export const ARTICLE_VALIDATION_TEXT = {
  [ARTICLE_VALIDATION.OFFLINE]: '下架',
  [ARTICLE_VALIDATION.ONLINE]: '上架'
}

/**
 * 文章状态类型映射
 */
export const ARTICLE_VALIDATION_TYPE = {
  [ARTICLE_VALIDATION.OFFLINE]: 'info',
  [ARTICLE_VALIDATION.ONLINE]: 'success'
}

/**
 * 商品类型
 */
export const GOODS_TYPE = {
  COURSE: 1      // 课程
}

/**
 * 分页默认配置
 */
export const PAGINATION_DEFAULT = {
  CURRENT: 1,
  SIZE: 10,
  SIZES: [10, 20, 50, 100]
}

/**
 * 文件上传限制
 */
export const UPLOAD_LIMITS = {
  IMAGE_MAX_SIZE: 10 * 1024 * 1024,      // 10MB
  VIDEO_MAX_SIZE: 500 * 1024 * 1024,     // 500MB
  ARCHIVE_MAX_SIZE: 2 * 1024 * 1024 * 1024  // 2GB
}

/**
 * 文件类型映射
 */
export const FILE_TYPE_MAP = {
  // 视频
  mp4: '视频',
  avi: '视频',
  mov: '视频',
  wmv: '视频',
  flv: '视频',
  mkv: '视频',
  webm: '视频',
  m4v: '视频',
  // 压缩包
  zip: '压缩包',
  rar: '压缩包',
  '7z': '压缩包',
  tar: '压缩包',
  gz: '压缩包',
  bz2: '压缩包',
  // 电子书
  epub: '电子书',
  pdf: 'PDF',
  mobi: '电子书',
  azw: '电子书',
  // Office文档
  doc: 'Word',
  docx: 'Word',
  xls: 'Excel',
  xlsx: 'Excel',
  ppt: 'PPT',
  pptx: 'PPT',
  // 文本
  txt: '文本',
  md: 'Markdown',
  // 图片
  jpg: '图片',
  jpeg: '图片',
  png: '图片',
  gif: '图片',
  bmp: '图片',
  svg: '图片',
  webp: '图片'
}

